export default __webpack_public_path__ + "static/media/jpg_icon.59f10bf2.png";